var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email 1",
    clipPath: "url(#clip0_202_7220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.5215 55.1414C50.2824 56.6341 47.6815 57.4232 45 57.4232C42.3186 57.4232 39.7178 56.6341 37.4787 55.1414L0.599238 30.5543C0.394629 30.4179 0.195293 30.2757 0 30.1294V70.418C0 75.0372 3.74853 78.7031 8.2851 78.7031H81.7147C86.3339 78.7031 89.9998 74.9545 89.9998 70.418V30.1293C89.8042 30.2759 89.6045 30.4184 89.3994 30.555L52.5215 55.1414Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.52441 26.1664L40.4038 50.7537C41.7999 51.6844 43.3999 52.1497 44.9998 52.1497C46.6 52.1497 48.2001 51.6842 49.5962 50.7537L86.4756 26.1664C88.6825 24.696 90 22.2351 90 19.579C90 15.0121 86.2845 11.2968 81.7177 11.2968H8.28229C3.71549 11.2969 0 15.0122 0 19.5834C0 22.2351 1.31766 24.696 3.52441 26.1664Z",
    fill: "#52682F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_7220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.987a286c36656071b258bc75713e653a.svg";
export { ForwardRef as ReactComponent };